<template>
  <v-app id="inspire" style="background: #f8f9fa">
    <div class="ma-0 pr-6 pl-6">
      <titleAgency></titleAgency>
      <v-tabs v-model="tab" color="#2BA197" style="margin-top: 0px;" background-color="titlebackground">

        <v-tabs-slider class="ml-0" color="#2BA197"></v-tabs-slider>

        <v-tab v-for="item in items" :key="item" style="font-weight: 700;font-size: 16px;letter-spacing: 1px;">
          <!-- {{ item }} -->
          <span class="ml-2">{{ item }}</span>
        </v-tab>

        <v-tabs-items v-model="tab" style="border-radius: 16px;">
          <v-tab-item>
            <div class="my-0">
              <div>
                <!-- <tableAgency/> -->
                <filterCurrent class="mx-5" />
                <tableCurrent class="mx-5 mb-5" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="my-0">
              <div>
                <filterApprove class="mx-5" />
                <tableApprove class="mx-5 mb-5" />
              </div>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="my-0">
              <div>
                <!-- <tableAgency/> -->
                <filterAgency class="mx-5" />
                <tableEmployee class="mx-5 mb-5" />
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </v-app>
</template>

<script>
import titleAgency from '@/components/_manageemployee/_overview/title.vue'
import filterCurrent from '@/components/_manageemployee/_overview/filterCurrent.vue'
import filterAgency from '@/components/_manageemployee/_overview/filter.vue'
import filterApprove from '@/components/_manageemployee/_overview/filterApprove.vue'
import tableEmployee from '@/components/_manageemployee/_overview/table.vue'
import tableCurrent from '@/components/_manageemployee/_overview/tableCurrent.vue'
import tableApprove from '@/components/_manageemployee/_overview/tableApprove.vue'
import { EventBus } from '@/EventBus'

export default {
  components: {
    titleAgency,
    filterAgency,
    filterCurrent,
    filterApprove,
    tableEmployee,
    tableCurrent,
    tableApprove
  },
  data () {
    return {
      activeTab: 0,
      page: 'approve',
      render: true,
      tab: 0,
      items: [
        'พนักงานปัจจุบัน', 'พนักงานลาออก', 'พนักงานในระบบ'
      ]
    }
  },
  async created () {
    this.tab = this.$store.getters.getTab || 0
  },
  beforeRouteLeave (to, from, next) {
    if (!to.path.includes('/manageemployee')) {
      this.$store.commit('setTab', 0)
    }
    next()
  },
  watch: {
    tab: function (val) {
      this.$store.commit('setTab', val)
      EventBus.$emit('CheckTab', val)
      // EventBus.$off('opendialogmember')
      this.forceRerender()
    }
  },
  methods: {
    changeTab (item) {
      this.forceRerender()
    },
    forceRerender () {
      if (this.activeTab === 0) {
        this.page = 'approve'
      } else if (this.activeTab === 1) {
        this.page = 'acknowledge'
      }
      this.render = false
      this.$nextTick(() => {
        this.render = true
      })
    }
  }
}
</script>

<style scoped>
.v-tab {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: "600";
  font-size: 1.2rem;
}
</style>
